module.exports = __webpack_public_path__ + "img/16_6.bda7c3f3.png";